import React from 'react';
import { Progress } from 'reactstrap';
import './custom-progress.scss';

interface CustomProgressProps {
  progressStep: number;
  totalSteps: number;
}

const CustomProgress: React.FC<CustomProgressProps> = ({ progressStep, totalSteps }) => {
  // Calcul de la valeur en %
  const valuePercent = (progressStep / totalSteps) * 100;

  return (
    <div className='progress-customer-container'>
      {/* Label en haut à droite */}
      <div className='progressLabel'>
      <strong>Étape {progressStep}</strong> sur {totalSteps}
      </div>

      {/* Barre de progression */}
      <div className= 'progress-parent'>
        <Progress
          value={valuePercent}
          max={100}
          color="warning" 
          style={{
            borderRadius: '10px',
            height: '10px',
            overflow: 'hidden',
            backgroundColor: '#eee'
          }}
          bar={true} 
        />
      </div>
    </div>
  );
};

export default CustomProgress;
